module.exports = __webpack_public_path__ + "color.c7a33805.png";